module.exports = __webpack_public_path__ + "media/app/assets/races/troll_female-1afbc35bc720efa42d8d4674417266b3.png";